export default "__VITE_ASSET__LmmEWy7c__"